import React from 'react';
import { connect } from 'react-redux';
import { connect as mobxConnect } from 'store';
import { Creators as dealerCreators } from 'modules/resale/store/ducks/dealer';
import { Creators as userCreators } from 'modules/resale/store/ducks/user';

import MainContainer from './MainContainer';
import MainComponent from './MainComponent';

const MainContainerMobx = mobxConnect(MainContainer, [
  'userStore',
  'dealerStore',
]);

function ContainerAndComponent(props) {
  return <MainContainerMobx viewComponent={MainComponent} {...props} />;
}

function mapStateToProps(state, dispatch) {
  return {};
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    setCurrentDealer: dealer => {
      dispatch(dealerCreators.setCurrentDealer(dealer));
    },
    setCurrentUser: user => {
      dispatch(userCreators.setCurrentUser(user));
    },
    setUserSiteId: userSiteId => {
      dispatch(userCreators.setUserSiteId(userSiteId));
    },
    getCurrentUserInfosByDealerId: dealerId => {
      dispatch(userCreators.getCurrentUserInfosByDealerId(dealerId));
    },
  };
}

const Main = connect(
  mapStateToProps,
  mapDispatchToProps
)(ContainerAndComponent);

export default Main;
